<template>
  <main-layout>
    <iframe
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
      allowfullscreen="true"
      :src="src"
      :style="{
        display: 'block',
        border: 'none',
        position: 'absolute',
        width: '100%',
        height: 'calc(100dvh - var(--nav-height))'
      }"
    />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://ananda.notification-center.enterprise.zwiz.app/${this.currentLang}`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'open_external_link') {
        window.open(event.data.url, '_blank')
      } else if (event.data.event_id === 'copy_to_clipboard') {
        if (event.data.value) navigator.clipboard.writeText(event.data.value)
      } else if (event.data.event_id === 'open_link') {
        window.open(event.data.url, '_self')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/NotificationCenter/NotificationCenterIframe.vue